import React from 'react'
import PropTypes from 'prop-types'

import { HEADER_THEME, SPACING } from '../components/constants.js'
import Align from '../components/Align.jsx'
import Footer from '../components/Footer.jsx'
import Grid from '../components/Grid.jsx'
import Header from '../components/Header.jsx'
import Margin from '../components/Margin.jsx'
import Notes from '../components/Notes.jsx'
import Slide from '../components/Slide.jsx'

import useRect from '../hooks/useRect.js'
import Gradient from '../components/Gradient.jsx'

const Horizontal = (props) => {
  const [HeaderRect, headerRect] = useRect()
  const [NotesRect, notesRect] = useRect()
  const [LeftRect] = useRect()

  const { title, description, notes, page, content } = props

  return (
    <Slide>
      <Grid
        direction="horizontal"
        gap={0}
        items={[
          {
            component: (
              <>
                <LeftRect />
                <svg x={0} y={0} width={'100%'} height={'100%'}>
                  <Gradient
                    direction="bottom"
                    colors={[
                      { offset: '0%', stopColor: '#10441B' },
                      { offset: '100%', stopColor: '#13682B' },
                    ]}
                  />
                  <Margin left={SPACING} top={SPACING} right={SPACING} bottom={SPACING}>
                    <Align childrenRect={headerRect}>
                      <Header
                        title={title}
                        description={description}
                        {...HEADER_THEME.HORIZONTAL}
                        DelegatedRect={HeaderRect}
                      />
                    </Align>
                  </Margin>
                </svg>
              </>
            ),
            size: 0.36,
          },
          {
            component: (
              <Margin left={SPACING} top={SPACING} right={SPACING} bottom={SPACING + 48}>
                <Grid
                  direction="vertical"
                  gap={48}
                  items={
                    notes
                      ? [
                          {
                            component: content(),
                            size: 1,
                          },
                          {
                            component: (
                              <Notes content={notes} align="middle" DelegatedRect={NotesRect} />
                            ),
                            size: notesRect,
                          },
                        ]
                      : [
                          {
                            component: content(),
                            size: 1,
                          },
                        ]
                  }
                />
              </Margin>
            ),
            size: 0.64,
          },
        ]}
      />
      <Footer page={page} theme={{ background: 'light', icon: 'light' }} />
    </Slide>
  )
}

Horizontal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  notes: PropTypes.string,
  page: PropTypes.number.isRequired,
  content: PropTypes.func.isRequired,
}

Horizontal.defaultProps = {
  title: '',
  description: '',
  notes: '',
}

export default Horizontal
